module.exports = { "default": require("core-js/library/fn/symbol/iterator"), __esModule: true };